// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { useField } from "formik";

import { createMixedValidator } from "components/form/fields/fieldUtils";
import { getFieldTestId } from "utils/formik";

import { Select } from "../elements";
import { FieldWithOptionsProps } from "./propTypes";

export const SelectField = (props) => {
  const { name, values, required = true, dataTestId, validate } = props;

  const [field, meta] = useField({
    ...props,
    required,
    type: "select",
    validate: createMixedValidator(props.name, required, validate),
  });

  const getValues = () =>
    values.map(({ label, value, ...rest }) => ({
      value: value,
      text: label,
      ...rest,
    }));

  return (
    <Select
      {...field}
      {...meta}
      {...props}
      required={required}
      values={getValues()}
      dataTestId={dataTestId || getFieldTestId(name)}
    />
  );
};

SelectField.propTypes = FieldWithOptionsProps;
